export const rawStrArr2EnumLikeObj = <T extends string>(o: T[]): { [K in T]: K } =>
  o.reduce((acc, curr) => {
    acc[curr] = curr;
    return acc;
  }, Object.create(null));
